import styled from "styled-components";
import { themeTypes } from "../../../shared/styled/Theme";

export const StyledMatchWatch = styled.div`
  width: 180px;
  text-align: right;
  cursor: pointer;
  display: flex;
  gap: 8px;
`;

export const StyledMatchWatchPost = styled.div`
  svg {
    vertical-align: middle;
  }
`;

export const StyledMatchWatchPre = styled.div``;

export const StyledMatchWatchPreWrapper = styled.div`
  svg {
    vertical-align: middle;
  }
`;

export const StyledMatchWatchLive = styled.div`
  text-transform: capitalize;
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  color: ${(props) => props.theme.figma.base.color_offblack_100};
  font-size: ${(props) => props.theme.mixins.pxToRem(11)};
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: -0.02em;
  display: flex;
  justify-content: flex-end;
  gap: 4px;
`;

export const StyledAppleTvIconWrapper = styled.div`
  display: ${(props) => (props.showChevron ? "inline" : "none")};
`;

export const StyledMatchWatchLiveButton = styled.div`
  width: 140px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 11px 0;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.07),
    0px 0px 0px 0px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  background-color: ${(props) =>
    props.forceLightVersion
      ? props.theme.figma.base.color_white_100
      : props.theme.type === themeTypes.light
        ? props.theme.figma.base.color_offblack_100
        : props.theme.figma.base.color_white_100};

  svg {
    filter: none;
    fill: ${(props) =>
    props.forceLightVersion
      ? props.theme.figma.base.color_offblack_100
      : props.theme.type === themeTypes.light
        ? props.theme.figma.base.color_white_100
        : props.theme.figma.base.color_offblack_100};
  }
`;

export const StyledMatchWatchPostLabel = styled.span`
  text-transform: capitalize;
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  color: ${(props) => props.theme.figma.base.color_offblack_100};
  opacity: 0.6;
  font-size: ${(props) => props.theme.mixins.pxToRem(12)};
  font-weight: 500;
  line-height: 15px;
  margin-right: 8px;
`;

export const StyledMatchWatchPreLabel = styled.span`
  text-transform: capitalize;
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  color: ${(props) => props.theme.figma.base.color_offblack_100};
  opacity: 0.6;
  font-size: ${(props) => props.theme.mixins.pxToRem(12)};
  font-weight: 500;
  line-height: 15px;
  margin-right: 4px;
`;

export const StyledMatchWatchLiveWrapper = styled.div``;

export const StyledMatchWatchLiveLabel = styled.span``;

export const StyledMatchDetails = styled.div`
  text-transform: capitalize;
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  color: ${(props) => props.theme.figma.base.color_offblack_100};
  opacity: 0.6;
  font-size: ${(props) => props.theme.mixins.pxToRem(12)};
  font-weight: 500;
  line-height: .9375rem;
`;

export const StyledMatchCTA = styled.button`
  background-color: ${(props) => props.theme.figma.base.color_white_100};
  border: .0625rem solid ${(props) => props.theme.figma.base.color_white_75};
  cursor: pointer;
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  color: ${(props) => props.theme.figma.base.color_offblack_100};
  font-size: ${(props) => props.theme.mixins.pxToRem(12)};
  padding: .25rem .5rem;
  border-radius: .25rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 1.5rem;
  box-shadow: 0px 1px 7px 3px rgba(0, 0, 0, 0.07),
    0px 0px 0px 0px rgba(0, 0, 0, 0.16);

  > img {
    width: 1rem;
    height: 1rem;
    margin-left: .25rem;
  }


  svg {
    margin-left: .25rem;

    path {
      fill: ${(props) => props.theme.figma.base.color_offblack_100};
    }
  }
`;

export const StyledMatchHotelBookLabel = styled.span`
  text-transform: capitalize;
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  color: ${(props) => props.theme.figma.base.color_offblack_100};
  opacity: 0.6;
  font-size: ${(props) => props.theme.mixins.pxToRem(12)};
  font-weight: 500;
  line-height: .9375rem;
  margin-right: .25rem;
`;
